import * as path from 'path';
import * as fs from 'fs';
import { rng } from '..';

// Define the Card class
export class Card {
    name: string;
    imageUrl: string;

    constructor(name: string, imageUrl: string) {
        this.name = name;
        this.imageUrl = imageUrl;
    }

    serialize() {
        const imageNameWithoutQuery = this.imageUrl.split('?')[0];
        const imageName = path.basename(imageNameWithoutQuery);  // Get only the file name
        return {
            name: this.name, // Save only the image name
        };
    }

    static async deserialize(data: any, directoryPath: string) {
        const cardName = data.name;
        console.log("Looking for " + cardName);
    
        const imagePath = await Card.findImagePathRecursive(directoryPath, cardName);
    
        if (!imagePath) {
            throw new Error(`Image for card "${cardName}" not found in directory: ${directoryPath}`);
        }
    
        console.log('Found path! ' + imagePath + ' for card name ' + cardName);
    
        return new Card(cardName, imagePath);
    }
    
    static async findImagePathRecursive(directoryPath: string, cardName: string): Promise<string | null> {
        console.log("Reading directory for card " + cardName + " in " + directoryPath);
        
        const files = await fs.promises.readdir(directoryPath); // Use the passed directory path
        console.log("Files found in " + directoryPath + ": " + files.length);
    
        for (const file of files) {
            const filePath = path.join(directoryPath, file);
            const stat = await fs.promises.stat(filePath);
    
            if (stat.isDirectory()) {
                // Recursively search in subdirectory
                const found = await Card.findImagePathRecursive(filePath, cardName);
                if (found) return found;
            } else if (stat.isFile()) {
                // Improved matching logic: exact match on file basename
                const baseName = path.basename(file, '.png'); // Strip .png and compare
                if (baseName.toLowerCase() === cardName.toLowerCase()) {
                    return filePath;
                }
            }
        }
    
        // Return null if not found
        return null;
    }
    
}

// Define the Deck class
export class Deck {
    public cards: Card[] = [];

    constructor() {

        /*
        if (cards.length == 0) {
            this.cards = [];
        } else {
            this.cards = cards;
        }
        */
       //this.cards = [];
       this.cards = new Array();
    }

    // Function to add a card to the deck
    addCard(card: Card | undefined): void {
        if (card != undefined) {
            this.cards.push(card);
        } else {
            console.warn("adding an undefined card");
        }
    }

    // Function to shuffle the deck
    shuffle(): void {
        for (let i = this.cards.length - 1; i > 0; i--) {
            const j = Math.floor(rng.random() * (i + 1));
            [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
        }
    }

    // Function to get the top card of the deck
    takeTopCard(): Card | undefined {
        return this.cards.pop();
    }

    viewTopCard(): Card | undefined {
        return this.cards[this.cards.length - 1];
    }

    getCardCount(): number {
        return this.cards.length;
    }

    listCardNames(): string[] {
        return this.cards.map(card => card.name);
    }

    serialize() {
        return {
            cards: this.cards.map(card => card.serialize()),  // Assuming Deck has a `cards` array
        };
    }

    static async deserialize(data: any, directoryPath: string): Promise<Deck> {
        // Ensure all card deserialization operations complete using Promise.all
        const cards = await Promise.all(
            
            data.cards.map(async (cardData: any) => {
                console.log ('got card data to deserialize:', cardData);
                return await Card.deserialize(cardData, directoryPath);
            })
        );

        console.log('got cards', cards);

        return new Deck();
    }
}

